"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseEndpointMessageOutSerializer = void 0;
const endpointMessageOut_1 = require("./endpointMessageOut");
exports.ListResponseEndpointMessageOutSerializer = {
    _fromJsonObject(object) {
        return {
            data: object["data"].map((item) => endpointMessageOut_1.EndpointMessageOutSerializer._fromJsonObject(item)),
            done: object["done"],
            iterator: object["iterator"],
            prevIterator: object["prevIterator"],
        };
    },
    _toJsonObject(self) {
        return {
            data: self.data.map((item) => endpointMessageOut_1.EndpointMessageOutSerializer._toJsonObject(item)),
            done: self.done,
            iterator: self.iterator,
            prevIterator: self.prevIterator,
        };
    },
};
//# sourceMappingURL=listResponseEndpointMessageOut.js.map